import { useAtom } from 'jotai'
import {
  timelineContainerRefAtom,
  timelineWidthAtom
} from '../atoms/timelineUi.atom'

export const useTimelineDimensions = () => {
  const [timelineContainerRef] = useAtom(timelineContainerRefAtom)
  const [timelineWidth] = useAtom(timelineWidthAtom)

  return {
    timelineWidth,
    timelineContainerHeight: timelineContainerRef?.scrollHeight ?? 0
  }
}
